exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .menuButtons {\n  position: fixed;\n  bottom: 35px;\n  right: 50px; }\n\n:host .canvas {\n  padding: 0px;\n  margin: 0px;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/components/project-diagram/project-diagram.component.scss
// module id = ../../../../../src/app/modules/project-details/components/project-diagram/project-diagram.component.scss
// module chunks = main